import { useState } from "react";

import { Button } from "@shared/components/ui/Button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@shared/components/ui/card";

export const DebugCardCrash = () => {
  const [shouldCrash, setShouldCrash] = useState(false);

  const crashApp = () => {
    // This will not be caught by the error boundary, but can test uncaught handlers
    throw new Error("Simulated Crash from Debug Drawer (Uncaught)");
  };

  if (shouldCrash) {
    throw new Error("Simulated Render Crash from Debug Drawer (Caught)");
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Error Testing</CardTitle>
        <CardDescription>Test application error handling.</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-2">
        <Button variant="destructive" onClick={() => setShouldCrash(true)}>
          Trigger Error Boundary
        </Button>
        <Button variant="outline" onClick={crashApp}>
          Throw Error (Uncaught)
        </Button>
      </CardContent>
    </Card>
  );
};
